import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HcaUserManagementService } from '../../../../../shared/_services/hca-user-management.service';
import { HcaBrandService } from '../../../../../shared/_services/hca-brand.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../../../../shared/_services/util.service';
import { ImageFile } from '../../../../../shared/_data-model/image-file';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { HotelManagementService } from '../../../../../shared/_services/hotel-management.service';
import { environment } from '../../../../../../environments/environment';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-hca-brand',
  templateUrl: './hca-brand.component.html',
  styleUrls: ['./hca-brand.component.scss']
})
export class HcaBrandComponent implements OnInit {
  LanguageError: boolean;
  brandDetailsCopy: any;
  favError: any;
  favSizeError: any;
  logoError: any;
  logoSizeError: any;
  imageUrl: any;
  errorDetails: string;
  successMsg: string;
  settings: FormGroup;
  brand: FormGroup;
  hotelBrands: any[] = [];
  brandDetails: any[] = [];
  selectedBrand: any;
  selectedBrandIndex: number;
  languages: any[] = [];
  selectedRewards: any[] = [];
  imageFile_logo: ImageFile = new ImageFile;
  imageFile_favicon: ImageFile = new ImageFile;
  statusModal: BsModalRef;
  isDirty: boolean = false;
  isNewBrand: boolean = false;
  counter: number = 0;
  bsModalRef: BsModalRef;
  @ViewChild('uploadFile') uploadFile: any;
  @ViewChild('uploadFile2') uploadFile2: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  countries: any[] = [];

  constructor(
    private fb: FormBuilder,
    private hcaBrandService: HcaBrandService,
    private hcaUserManagementService: HcaUserManagementService,
    private hotelManagementService: HotelManagementService,
    private sanitizer: DomSanitizer,
    private utilService: UtilService,
    private modalService: BsModalService,
    private validationService: ValidationService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "hca-brand") {

              this.isDirty = false;
              const id: string = this.statusModal.content.srcObject.idx;
              setTimeout(() => {
                let element = document.getElementById(id);
                element.click();
                this.isDirty = false;
                this.brand.reset();
                this.imageFile_logo = new ImageFile;
                this.imageFile_favicon = new ImageFile;
              }, 50);

            }
          }
          if (this.statusModal.content.srcObject.type == "hca-image") {
            if (this.statusModal.content.srcObject.action == "action1") {
              this.isDirty = true;
              if (this.statusModal.content.srcObject.image == 'logo') {
                this.imageFile_logo = new ImageFile;
                this.brand.get('brandLogo').setValue('');
              }
              else if (this.statusModal.content.srcObject.image == 'favicon') {
                this.imageFile_favicon = new ImageFile;
                this.brand.get('favicon').setValue('');
              }
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-discard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              if (this.brand.get('brandId').value) {
                this.brand.patchValue(Object.assign({}, this.brandDetailsCopy));
                this.isDirty = false;
                //reset image
              }
              else {
                this.ngOnInit();
              }
            }
          }
        }
      })
  }

  ngOnInit() {
    this.initForm();
    this.getHotelBrandsByHotelChain();
    this.getLanguageCodes();
    this.getCountries();

  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  initForm(data?) {
    this.settings = this.fb.group({
      select: ['']
    });
    this.brand = this.fb.group({
      brandId: [data? data.brandId : null],
      brandLogo: [data ? data.brandLogo : ''],
      brandName: [data ? data.brandName : '', Validators.required],
      favicon: [data ? data.favicon : ''],
      hotelChainId: [data && data.hotelChainId ? data.hotelChainId : ''],
      languageId: [data && data.languageId ? data.languageId : '', Validators.required],
      // languagesList: this.fb.array([], this.validationService.minLengthArray(1)),
      name: [data && data.name ? data.name : ''],
      physicalCardCountries: this.fb.array([]),
      isMemberShipRequired: [data && data.isMemberShipRequired ? data.isMemberShipRequired : false],
      smartCode: [data && data.smartCode ? data.smartCode : '', Validators.compose([Validators.required, Validators.maxLength(4)])],
      voucherEmailId: [data && data.voucherEmailId ? data.voucherEmailId : ''],
      website: [data && data.website ? data.website : '', Validators.compose([Validators.required, Validators.pattern(this.validationService.webUrl_regexPattern)])],
      blogUrl: [data && data.blogUrl ? data.blogUrl : '', Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])]
    });
    if(data && data.physicalCardCountries && data.physicalCardCountries.length) {
      data.physicalCardCountries.forEach(country => {
        this.addCountry(country);
      })
    }
    // if(data && data.languagesList && data.languagesList.length) {
    //   data.languagesList.forEach(language => {
    //     this.addLanguage(language);
    //   })
    // }
    this.brand.controls['physicalCardCountries'].valueChanges.subscribe(data => {
      this.brand.controls['physicalCardCountries'].markAsDirty();
    });

    this.brand.valueChanges.subscribe(data => {
      if (this.brand.dirty) {
        this.isDirty = true;
      }
      else {
        this.isDirty = false;
      }
    });
  }

  addLanguage(langauge) {
    let formCtrl = this.brand.get('languagesList') as FormArray;
    formCtrl.push(new FormControl(langauge));
  }

  addCountry(countryId) {
    let formArray = this.brand.controls['physicalCardCountries'] as FormArray;
      formArray.push(new FormControl(countryId));
  }

  addBrand() {
    this.hotelBrands.push({ "brandName": "New Brand" });
    setTimeout(() => {
      const i = this.hotelBrands.length - 1;
      let element = document.getElementById(i.toString());
      element.click();
      this.isDirty = false;
      this.brand.reset();
      this.brand.get('isMemberShipRequired').patchValue(false);
      this.brand.get('languageId').patchValue('');
      this.imageFile_logo = new ImageFile;
      this.imageFile_favicon = new ImageFile;
    }, 50);

  }
  yes() {
    this.isDirty = false;
  }
  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {

        if (res.error == 0) {
          this.hotelBrands = [];
          this.hotelBrands = res.responseObj;
          this.isDirty = false;
          if (this.hotelBrands.length > 0) {
            if (this.isNewBrand) {

              if (this.selectedBrand.brandId > 0) {
                setTimeout(() => {
                  for (let i = 0; i < this.hotelBrands.length; i++) {
                    if (this.selectedBrand.brandId == this.hotelBrands[i].brandId) {
                      let element = document.getElementById(i.toString());
                      element.click();
                      //this.getBrandDetailsByBrandId(this.selectedBrand, i);
                    }
                  }
                }, 0);
              }
            }
            else {
              this.selectedBrand = res.responseObj[0];
              this.selectedBrandIndex = 0;
              this.getBrandDetailsByBrandId(this.selectedBrand, 0);
            }
          }
        }
        else {
          console.error("Get Hotel Brands : ", res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  stayOnPage(brand, i) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-brand',
      title: 'Confirm',
      status: 'Active',
      message: 'Do you want to edit another brand? Changes to this brand have not been saved.',
      action1: 'Yes',
      action2: 'No',
      action: '',
      idx: i,
      style: 'active'
    }
  }
  deleteImage(mode) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      image: mode,
    }
  }

  getBrandDetailsByBrandId(brand, i) {
    this.logoError = false;
    this.favError = false;
    if (brand.brandId) {
      this.selectedBrand = brand;
      this.selectedBrandIndex = i;
      this.hcaBrandService.getBrandDetailsByBrandId(brand.brandId).subscribe(
        res => {
          if (res.error == 0) {
            this.brandDetailsCopy = Object.assign({}, res.responseObj);
            // this.brand.patchValue(res.responseObj);
            this.initForm(res.responseObj);
            if (res.responseObj.brandLogo && res.responseObj.brandLogo != "null") {
              this.imageFile_logo.name = res.responseObj.brandLogo;
              this.imageFile_logo.imageUrl = res.responseObj.brandLogo && res.responseObj.brandLogo.indexOf('/home/ubuntu') == -1 ? `${environment.BASE_IMAGE_API}/images/brands/${res.responseObj.brandId}/${res.responseObj.brandLogo}` : ``;
            }
            else {
              this.imageFile_logo.name = "";
              this.imageFile_logo.imageUrl = "";
            }
            if (res.responseObj.favicon && res.responseObj.favicon != "null") {
              this.imageFile_favicon.name = res.responseObj.favicon;
              this.imageFile_favicon.imageUrl = res.responseObj.favicon && res.responseObj.favicon.indexOf('/home/ubuntu') == -1 ? `${environment.BASE_IMAGE_API}/images/brands/${res.responseObj.brandId}/${res.responseObj.favicon}` : ``;
            }
            else {
              this.imageFile_favicon.name = "";
              this.imageFile_favicon.imageUrl = "";
            }
            this.isDirty = false;
          }
          else {
            console.error("Get Brand Details : ", res.message);
          }
        }, err => {
          console.error(err);
        });
    }
    else {
      this.brand.reset();
      this.imageFile_logo = new ImageFile;
      this.imageFile_favicon = new ImageFile;
      console.log("new brand");
    }
  }
  getLanguageCodes() {
    this.hcaBrandService.getLanguageCodes().subscribe(
      res => {
        if (res.error == 0) {
          this.languages = res.responseObj;
          console.log("Get Languages : ", res.responseObj);
          if (res.responseObj.length > 0) {
          }
        }
        else {
          console.error("Get Languages : ", res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getCountries() {
    this.hcaBrandService.getCountries().subscribe(
      res => {
        if (res.error == 0) {
          this.countries = res.responseObj;
        }
        else {
          console.error("Get countries : ", res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('members-filter').style.display == 'block') {
      document.getElementById('members-filter').style.display = 'none';
    } else {
      document.getElementById('members-filter').style.display = 'block';
    }
  }

  checkSelected(isChecked: boolean, controlName, value) {
    let formArray = this.brand.controls[controlName] as FormArray;
    if (isChecked) {
      formArray.push(new FormControl(value));
    } else {
      let index = formArray.controls.findIndex(x => x.value == value);
      if (index > -1) {
        formArray.removeAt(index);
      }
      if (formArray.value.indexOf(0) > -1) {
        if (this.countries.length != formArray.value.length - 1) {
          let idx = formArray.controls.findIndex(x => x.value == 0);
          if (idx > -1) {
            formArray.removeAt(idx);
          }
        }
      }
    }
  }

  uploadImage(event: any, mode) {
    if (mode == "logo") {
      this.imageFile_logo = this.utilService.uploadImage(event);
      this.logoError = this.imageFile_logo.errorUpload;
      this.logoSizeError = this.imageFile_logo.fileSizeError;
      setTimeout(() => {
        this.logoError = false;
        this.logoSizeError = false;
      }, 1000);
      if (this.logoError || this.logoSizeError) {
        this.imageFile_logo.imageUrl = "";
      }
      this.resetFileInput('uploadFile');
    }
    else if (mode == "favicon") {
      this.imageFile_favicon = this.utilService.uploadImage(event);
      this.favError = this.imageFile_favicon.errorUpload;
      this.favSizeError = this.imageFile_favicon.fileSizeError;
      setTimeout(() => {
        this.favError = false;
        this.favSizeError = false;
      }, 1000);
      if (this.favError || this.favSizeError) {
        this.imageFile_favicon.imageUrl = "";
      }
      this.resetFileInput('uploadFile2');
    }
    if (!this.brand.get('brandId').value && !this.logoError && !this.logoSizeError && !this.favError && !this.favSizeError) {
      //New Brand
      this.saveImageFile(mode);
    }
    this.isDirty = true;
  }

  resetFileInput(element?) {
    console.log(this[element].nativeElement.files);
    this[element].nativeElement.value = "";
    console.log(this[element].nativeElement.files);
  }

  toggleSelection(language) {
    setTimeout(() => {
      let formControl = this.brand.get('languagesList') as FormArray;
      let idx = formControl.controls.findIndex(x => x.value == parseInt(language.id));
      if (idx > -1) {
        // formControl.controls.splice(idx, 1);
        formControl.removeAt(idx);
      } else {
        formControl.push(new FormControl(language.id));
        // this.selectedLevels.push(parseInt(level.loyaltyId));
      }
      this.checkError(formControl);
    }, 100);
  }

  checkError(control) {
    this.errorDetails = '';
    if (!control.value.length) {
      this.LanguageError = true;
    } else {
      this.LanguageError = false;
    }
  }


  saveImageFile(mode) {
    //Add New Brand
    //  File Should be saved first
    let formData: any = new FormData();
    if (mode == "logo") {
      // let fileName = this.imageFile_logo.name ? `${this.utilService.getRandomInt(0, 1000000)}_${this.imageFile_logo.name}` : 'this.utilService.getRandomInt(0, 1000000)';
      let fileName = this.imageFile_logo.name ? this.utilService.getModifiedString(this.imageFile_logo.name) : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile_logo.file, fileName);
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          this.resetFileInput('uploadFile');
          this.brand.get('brandLogo').patchValue(res.responseObj);
          
        }
        else {
          this.resetFileInput('uploadFile');
          console.log("Error uploading file");
        }
      }, err => {
        this.resetFileInput('uploadFile');
      })
    }
    else if (mode == "favicon") {
      let fileName = this.imageFile_favicon.name ? this.utilService.getModifiedString(this.imageFile_favicon.name) : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile_favicon.file, fileName);
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          this.resetFileInput('uploadFile2');
          this.brand.get('favicon').patchValue(res.responseObj);
        }
        else {
          this.resetFileInput('uploadFile2');
          console.log("Error uploading file");
        }
      }, err => {
        this.resetFileInput('uploadFile2');
      })
    }
    console.log("logo ", this.brand.get('brandLogo').value);
    console.log("favicon ", this.brand.get('favicon').value);
  }

  createBrand() {
    let hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    const hotelChainIdCtrl = this.brand.get("hotelChainId");
    hotelChainIdCtrl.patchValue(hotelChainId);
    this.hcaBrandService.createBrand(this.brand.value)
      .subscribe(
      (res) => {
        if (res.error == 0) {
          this.isDirty = false;
          this.isNewBrand = true;
          this.selectedBrand = res.responseObj;
          this.successMsg = "Changes saved successfully";
          setTimeout(() => {
            this.successMsg = "";
          }, 2500);
          this.getHotelBrandsByHotelChain();
          console.log(res.responseObj);
        }
        else {
          this.errorDetails = res.message;
        }
      },
      (err) => {
        this.errorDetails = err.message;
        console.error("Create Brand : ", err.message);
      });
  }

  updateBrandDetails() {
    this.successMsg = "";
    let formData: any = new FormData();
    formData.append('brandJson', JSON.stringify(this.brand.value));

    if (this.imageFile_logo.name && !this.imageFile_logo.errorUpload && !this.imageFile_logo.fileSizeError) {
      let r = this.imageFile_logo.name.split('_');
      console.log("aaa "+r[0]);
      console.log("bb "+r[1]);
      let fileName = this.imageFile_logo.name ? this.utilService.getModifiedString(this.imageFile_logo.name) : this.utilService.getRandomInt(0, 1000000);
      if(this.imageFile_logo.file){
        formData.append('brandLogo', this.imageFile_logo.file, fileName);
      }else{
        let blobImage = new Blob([], { type: 'image/jpg' });
        formData.append('brandLogo', blobImage, null);
      }

    }
    else if (this.brand.get('brandLogo').value) {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('brandLogo', file, this.brand.get('brandLogo').value);
    }
    else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('brandLogo', null);
    }

    if (this.imageFile_favicon.name && !this.imageFile_favicon.errorUpload && !this.imageFile_favicon.fileSizeError) {
      let fileName = this.imageFile_favicon.name ? this.utilService.getModifiedString(this.imageFile_favicon.name) : this.utilService.getRandomInt(0, 1000000);
      //let blobFile = new Blob([this.imageFile_favicon.file ? this.imageFile_favicon.file : this.imageFileObj_favicon.file], { type: 'image/jpg' });
      //formData.append('favicon', blobFile, fileName);

      if(this.imageFile_favicon.file){
        formData.append('favicon', this.imageFile_favicon.file, fileName);
      }else{
        let blobFile = new Blob([], { type: 'image/jpg' });
        formData.append('favicon', blobFile, null);
      }


    } 
    else if (this.brand.get('favicon').value) {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('favicon', file, this.brand.get('favicon').value);
    }
    else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('favicon', null);
    }

    this.hcaBrandService.updateBrandDetails(formData)
      .subscribe(
      (res) => {
        if (res.error == 0) {
          this.hotelBrands[this.selectedBrandIndex].brandName = res.responseObj.brandName;
          this.successMsg = "Changes saved successfully";
          this.isDirty = false;
          this.brand.reset();
          this.imageFile_logo = new ImageFile();
          this.imageFile_favicon = new ImageFile();
          this.getBrandDetailsByBrandId(this.selectedBrand, this.selectedBrandIndex);
          setTimeout(() => {
            this.successMsg = "";
          }, 2500);
        }
        else {
          this.errorDetails = res.message;
        }
      },
      (err) => {
        this.errorDetails = err.message;
        console.error("Update Brand Details : ", err);
      });
  }
  discardChanges() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-discard',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to cancel?',
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  getBrandDefaultVoucherEmailId() {
    if(this.brand.get("brandName").value =='Sandos Hotels & Resorts'){
      return environment.sandos_callcenter_emailId;
    }else if(this.brand.get("brandName").value =='M4Online'){
      return environment.m4u_callcenter_emailId;
    }
  }

  checkForVoucherBrand() {
    if(this.brand.get("brandName").value =='Sandos Hotels & Resorts'||this.brand.get("brandName").value =='M4Online'){
      return true;
    }  
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-brand/hca-brand.component.ts